// extracted by mini-css-extract-plugin
module.exports = {"loader":"ta","smallLoader":"ua","loading-keyframes":"va","pageLoader":"wa","centered":"xa","whitespacePlaceholder":"ya","buttonSpinner":"za","fade-in":"Aa","rotate":"Ba"};